const headers = {
  name: "Closing Balances",
  components: [
    {
      type: "date",
      name: "start_date",
      placeholder: "Start Date",
      value: "",
    },
    {
      type: "date",
      name: "end_date",
      placeholder: "End Date",
      value: "",
    },
    {
      type: "add",
      path: "/app/settings/closing-balance/add",
    },
  ],
  navigate: {
    tabs: [
      { name: "Settings", path: "/app/settings" },
      { name: "Closing Balances", path: "" },
    ],
  },
};

export default headers;